import { gql } from 'apollo-angular';

const CREATE_USER = gql`
  mutation newUser(
    $contactInfo: ContactInfoRequest!
    $notifications: [NotificationRequest]
    $permissions: [UserPermissionType]
    $allOrgsAssigned: Boolean!
    $organizations: [Long]!
  ) {
    newUser(
      newUserRequest: {
        contactInfo: $contactInfo
        notifications: $notifications
        permissions: $permissions
        assignedOrganizations: {
          allOrgsAssigned: $allOrgsAssigned
          organizations: $organizations
        }
      }
    ) {
      id
      firstName
      lastName
      emailAddress
      mobilePhone
    }
  }
`;

export default CREATE_USER;
